import { defineQuery } from 'next-sanity';

// ========== Sitemap page ==========
export const SITEMAP_QUERY = defineQuery(`
*[_type in ["blog", "careerType", "caseStudy", "news", "resource", "faq", "video"] && defined(slug.current)] {
    "href": select(
      _type == "blog" => "/blog/" + slug.current,
      _type == "careerType" => "/careers/" + slug.current,
      _type == "caseStudy" => "/case-studies/" + slug.current,
      _type == "news" => "/news/" + slug.current,
      _type == "resource" => "/resources/" + slug.current,
      _type == "faq" => "/support/" + slug.current,
      _type == "video" => "/videos/" + slug.current,
      slug.current
    ),
    _updatedAt
}
`);

export const SITEMAP_SLUG_COUNT_QUERY = defineQuery(`
{
  "blog": count(*[_type == "blog" && defined(slug.current)]),
  "careers": count(*[_type == "careerType" && defined(slug.current)]),
  "case-studies": count(*[_type == "caseStudy" && defined(slug.current)]),
  "news": count(*[_type == "news" && defined(slug.current)]),
  "resources": count(*[_type == "resource" && defined(slug.current)]),
  "support": count(*[_type == "faq" && defined(slug.current)]),
  "videos": count(*[_type == "video" && defined(slug.current)])
}
`);

export const BLOG_SITEMAP_QUERY = defineQuery(`
*[_type == "blog" && defined(slug.current)] {
    _id,
    "href": "blog/" + slug.current,
    _updatedAt
}`);

export const CAREERS_SITEMAP_QUERY = defineQuery(`
*[_type == "careerType" && defined(slug.current)] {
    _id,
    "href": "careers/" + slug.current,
    _updatedAt
}`);

export const CASESTUDIES_SITEMAP_QUERY = defineQuery(`
*[_type == "caseStudy" && defined(slug.current)] {
    _id,
    "href": "case-studies/" + slug.current,
    _updatedAt
}`);

export const NEWS_SITEMAP_QUERY = defineQuery(`
*[_type == "news" && defined(slug.current)] {
    _id,
    "href": "news/" + slug.current,
    _updatedAt
}`);

export const RESOURCES_SITEMAP_QUERY = defineQuery(`
*[_type == "resource" && defined(slug.current)] {
    _id,
    "href": "resources/" + slug.current,
    _updatedAt
}`);

export const SUPPORT_SITEMAP_QUERY = defineQuery(`
*[_type == "faq" && defined(slug.current)] {
    _id,
    "href": "support/" + slug.current,
    _updatedAt
}`);

export const VIDEOS_SITEMAP_QUERY = defineQuery(`
*[_type == "video" && defined(slug.current)] {
    _id,
    "href": "videos/" + slug.current,
    _updatedAt
}`);
